<template>
    <ErrorPage>
        <template slot="Title">
            This looks empty
        </template>
        <template slot="SubTitle">
        </template>
        <template slot="Content">
           You can upload tracks here
        </template>
        <template slot="Actions">
            <UploadButton />
        </template>
    </ErrorPage>
</template>

<script>
    import ErrorPage from'@/components/common/ErrorPage.vue'
    import  UploadButton from "@/components/Library/UploadButton"
    export default {
        name: "TrackListEmpty",
        components: {
            ErrorPage,UploadButton
        },
    }
</script>

<style scoped>
</style>
